module.exports = __webpack_public_path__ + "static/media/permanentDelete.1d5dc07a.svg";